import './style/index.js';

import _Avatar from './avatar';
import _AvatarGroup from './avatar-group';

export type { AvatarProps } from './avatar';
export const Avatar = _Avatar;
export const AvatarGroup = _AvatarGroup;

export default Avatar;

export * from './type';
